const Pin = {
    name: 'PIN',
    options: {
        regexp: '^[0-9]{0,${NODMAX}}$',
        numberOfDigitsMin: undefined,
        numberOfDigitsMax: undefined
    },
    init: options => {
        const getNumberOfDigits = validatorName => {
            if (validatorName.indexOf('-') > -1) {
                const digits = validatorName.replace('PIN', '').split('-');
                if (Array.isArray(digits) && digits.length === 2) {
                    return {
                        numberOfDigitsMin: digits[0],
                        numberOfDigitsMax: digits[1]
                    };
                } else {
                    return;
                }
            } else {
                const numberOfDigits = validatorName.replace('PIN', '');
                if (numberOfDigits) {
                    return {
                        numberOfDigitsMin: parseInt(numberOfDigits),
                        numberOfDigitsMax: parseInt(numberOfDigits)
                    };
                } else {
                    return;
                }
            }
        };

        const numberOfDigits = getNumberOfDigits(options.name.toUpperCase());
        if (numberOfDigits) {
            Pin.options.numberOfDigitsMin = numberOfDigits.numberOfDigitsMin;
            Pin.options.numberOfDigitsMax = numberOfDigits.numberOfDigitsMax;
        }
    },
    validate: value => {
        let isValidValue = false;
        let isValidLength = false;

        if (!Pin.options.numberOfDigitsMin || !Pin.options.numberOfDigitsMax) {
            return;
        }

        const regexp = Pin.options.regexp.replace(
            '${NODMAX}',
            Pin.options.numberOfDigitsMax
        );

        if (regexp && value.match(new RegExp(regexp))) {
            isValidValue = true;
        }

        if (
            value &&
            value.length >= Pin.options.numberOfDigitsMin &&
            value.length <= Pin.options.numberOfDigitsMax
        ) {
            isValidLength = true;
        } else if (value && value.length > Pin.options.numberOfDigitsMax) {
            isValidValue = false;
        }

        return {
            isValidValue,
            isValidLength
        };
    }
};

export default Pin;
